import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'
import {Icon} from '@components/common/base/icon'
import {InputNew} from '@components/common/base/input-new'
import {
  TwPage,
  TwTitle,
  TwTitleText
} from '@components/sticker/my-stickers/containers'
import {useMyStickersStore} from '../my-stickers-store'
import {List} from './list/list'

export const StickerLibrary = observer(() => {
  const [state, store] = useMyStickersStore()

  return (
    <TwPage>
      <TwTitle className="pb-16">
        <LinkButtonNew
          title={Lang.msg.myStickers.boardStickersTitle}
          onClick={() => store.setCurrentTab('board')}
        />
        <TwTitleText className="ml-auto">
          <Icon icon="IconCustomExistingPlus" />
          {Lang.msg.myStickers.otherBoardsStickers}
        </TwTitleText>
      </TwTitle>
      <div className="py-8 text-sm-semibold text-primary">
        {Lang.msg.myStickers.otherBoardsStickers}
      </div>
      <InputNew
        icon="IconSearch"
        placeholder={Lang.msg.myStickers.search}
        value={state.searchQuery}
        onChange={(v): void => store.setSearchQuery(v)}
      />
      <List highlight={Boolean(state.searchQuery)} />
    </TwPage>
  )
})
